import { Target, TrendingUp } from "lucide-react"

import { FrontendTriggerDefinition } from "@/components/automations/types"

export const opportunityTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__opportunity_created",
    label: "Opportunity created",
    description: "Triggers when a new opportunity is created",
    icon: Target,
    providesSubjects: ["opportunity", "household"],
    inputFields: [
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: true,
        filterEntity: "opportunity",
        requiredConditionFields: ["pipeline_id"],
      },
    ],
  },
  {
    key: "trigger__opportunity_stage_moved",
    label: "Stage moved",
    description: "Triggers when an opportunity moves stages",
    icon: TrendingUp,
    providesSubjects: ["opportunity", "household"],
    inputFields: [
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: true,
        filterEntity: "opportunity",
        requiredConditionFields: ["pipeline_id"],
      },
    ],
  },
]
